class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.updateStickyAddToCart();
      this.renderProductInfo();
    }
  }

  // The bar adds whatever variant id it carries, so switch that right away; its
  // image, title and price follow once renderProductInfo has the new section.
  updateStickyAddToCart() {
    const stickyBar = document.getElementById(`StickyAddToCart-${this.dataset.section}`);
    if (stickyBar) stickyBar.setAttribute('data-current-var', this.currentVariant.id);
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
    
    // Change description for selected variant 
    
    // A radio combination can legitimately match no variant; bail out before
    // touching the DOM so onVariantChange can run its setUnavailable() path.
    if (!this.currentVariant) return;

    var selectedVarId = this.currentVariant.id,
        productVarPreOrder =  document.querySelectorAll('.pre-order-text-variant'),
        productVarCustomTxt =  document.querySelectorAll('.msg-text');

    if(selectedVarId == 26663041531968 || selectedVarId == 39715367649343 || selectedVarId == 26662448889920 || selectedVarId == 39733226864703 || selectedVarId == 39733226897471 || selectedVarId == 39771378483263 || selectedVarId == 39491615359039 || selectedVarId == 39890227494975 || selectedVarId == 39652777132095 || selectedVarId == 39890228609087 || selectedVarId == 32335645933631 ) {
      $(document).find('.eligible-text').css('display','block');
    } else {
      $(document).find('.eligible-text').css('display','none');
    }

    if (selectedVarId == 39518561402943 || selectedVarId == 39491615359039) {
      $(document).find('.discount-messaging').css('display','none');
    } else {
      $(document).find('.discount-messaging').css('display','block');
    }

    // if (selectedVarId == 39518561402943 || selectedVarId == 39491615359039) {
    //   $(document).find('.product-red-text-sale').removeClass('hide');
    // } else {
    //   $(document).find('.product-red-text-sale').addClass('hide');
    // }
    
    // Every variant's description / material / dimensions is pre-rendered and all but
    // the selected one carries `hide`. Reveal the copy for the newly selected variant.
    // `.product__variant-description` is the legacy product-tabs markup;
    // `.product-variant-description__item` is the variant_description block on the new PDP.
    [
      '.product__variant-description',
      '.product-variant-description__item',
      '.product__variant-material',
      '.product__variant-size'
    ].forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (item) {
        // Copy coming from a product level metafield is rendered once, without a
        // data-variant-id, and stays visible for every variant.
        if (!item.dataset.variantId) return;
        item.classList.toggle('hide', item.dataset.variantId !== String(selectedVarId));
      });
    });

    for (var i = 0; i < productVarPreOrder.length; i++) {
      productVarPreOrder[i].classList.add('hide');
    }
    for (var i = 0; i < productVarCustomTxt.length; i++) {
      productVarCustomTxt[i].classList.add('hide');
    }

    var selectedPreOrder = document.querySelector('.pre-order-text-variant[data-variant-id="' + selectedVarId + '"]'),
        selectedCustomTxt = document.querySelector('.msg-text[data-variant-id="' + selectedVarId + '"]'),
        preOrderProperty = document.getElementById('preOrderProperty'),
        waitlistLink = document.querySelector('.join-waitlist-link');

    var selectedPreOrderVariant = selectedPreOrder
      ? selectedPreOrder.textContent.replace('Preorder: ', '')
      : '';

    if (preOrderProperty) {
      preOrderProperty.disabled = selectedPreOrderVariant.trim() === '';
      preOrderProperty.value = selectedPreOrderVariant;
    }

    if (selectedPreOrder) selectedPreOrder.classList.remove('hide');
    if (selectedCustomTxt) selectedCustomTxt.classList.remove('hide');

    if (waitlistLink) {
      var invPolicy = selectedPreOrder ? selectedPreOrder.dataset.inventoryPolicy : '',
          variantText = selectedPreOrder ? selectedPreOrder.innerText : '';

      waitlistLink.style.display = (invPolicy == 'deny' && variantText == '') ? 'block' : 'none';
    }
  }

  updateMedia() {
    
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
        
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if(document.body.contains(document.querySelector('.section--featured-product'))){
      console.log('Element exists!');
    } else {
      if (!this.currentVariant) return;
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        ['.sticky-add-to-cart_image', '.sticky-add-to-cart_info'].forEach((selector) => {
          const stickyId = `StickyAddToCart-${this.dataset.section}`;
          const stickySource = html.getElementById(stickyId)?.querySelector(selector);
          const stickyDestination = document.getElementById(stickyId)?.querySelector(selector);
          if (stickySource && stickyDestination) stickyDestination.innerHTML = stickySource.innerHTML;
        });

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        window.loyaltylion && window.loyaltylion.ui.refresh();
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    const buttonKlaviyo = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="klaviyo"]');

    if (!addButton) return;

    var shippingEstimate = document.querySelector('.shipping-estimate'),
        visiblePreOrder = document.querySelector('.pre-order-text.pre-order-text-variant:not(.hide)');

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;

      if (shippingEstimate) shippingEstimate.classList.add('hide');

    } else {
      addButton.removeAttribute('disabled');

      var isPreOrder = visiblePreOrder
        && this.currentVariant
        && this.currentVariant.id == visiblePreOrder.dataset.variantId
        && visiblePreOrder.innerText != '';

      if (isPreOrder) {
        addButton.textContent = window.PreOrder.PreOrder;
        if (shippingEstimate) shippingEstimate.classList.add('hide');
      } else {
        addButton.textContent = window.variantStrings.addToCart;
        if (shippingEstimate) shippingEstimate.classList.remove('hide');
      }
    }

     if(buttonKlaviyo && modifyClass){
       if (disable) {
         addButton.style.display = "none";
         buttonKlaviyo.style.display = "flex";
       } else {
         addButton.style.display = "flex";
         buttonKlaviyo.style.display = "none";
      }
     }
    
    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);